import React from "react"

import useQuery from "../hooks/useQuery"
import { SDKContextType, SDKContextProviderProps } from "./types"
import { useValidateRoom } from "../hooks/useValidateRoom"

let resolveFunc: ((value: SDKContextType) => void) | null = null
export const resolveSDKContextStatus = (meetingClient: SDKContextType) =>
  resolveFunc && resolveFunc(meetingClient)
export const sdkContextStatus = new Promise<SDKContextType>(resolve => {
  resolveFunc = resolve
})

declare global {
  interface Window {
    MeetOnline: any
    LSRTC: any
    AndroidNativeHandler: any // Android will add this property inside window
    webkit: any // IOS native app will add this property inside window
  }
}

const MeetOnline = window.MeetOnline

export const SDKContext = React.createContext<SDKContextType | null>(null)

export const useSDKContext = () => {
  const meetingClient = React.useContext(SDKContext)
  if (!meetingClient) {
    throw "Meeting client is not defined"
  }
  return meetingClient
}

export const SDKContextProvider = (props: SDKContextProviderProps) => {
  const query = useQuery()

  const [meetingClient, setMeetingClient] =
    React.useState<SDKContextType | null>(null)

  const { validatePrivateRoom, validateRoom } = useValidateRoom(meetingClient)

  const initSDK = () => {
    const _meetingClient = MeetOnline?.createClient({
      userName: query.userName,
      roomHash: query.roomHash,
      connectAgora: query.connectAgora
    })
    return _meetingClient
  }

  React.useEffect(() => {
    const _meetingClient = initSDK()
    setMeetingClient(_meetingClient)

    return () => {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    if (
      meetingClient &&
      query.roomHash !== "shows" &&
      query.roomHash !== "avatars" &&
      query.roomHash !== "journey" &&
      query.roomHash !== "user-login" &&
      query.roomHash !== "user-register" &&
      query.roomHash !== "user-verify" &&
      query.roomHash !== "user-password-reset" &&
      query.roomHash !== "plans"
    ) {
      validatePrivateRoom()
      validateRoom()
    }

    if (meetingClient != null) resolveSDKContextStatus(meetingClient)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetingClient])

  return (
    <SDKContext.Provider value={meetingClient}>
      {props.children}
    </SDKContext.Provider>
  )
}
